import { getProductDepartment } from './productRoutes';

export const STORE_TESTIMONIALS = [
  {
    id: 1,
    name: 'Sarah Wanjiku',
    location: 'Nairobi',
    rating: 5,
    text: 'Trendy Quest Collection has the most comfortable casual shoes I have ever worn. Perfect for my daily walks and they still look polished when I head to meetings.',
    product: 'Casual Sneakers',
    departments: ['Women', 'Men'],
    date: 'May 2026',
  },
  {
    id: 2,
    name: 'David Kiprop',
    location: 'Eldoret',
    rating: 5,
    text: 'I bought formal shoes for work and they exceeded my expectations. Great fit, excellent finish, and they have held up perfectly after months of daily wear.',
    product: 'Formal Oxfords',
    departments: ['Men'],
    date: 'April 2026',
  },
  {
    id: 3,
    name: 'Grace Achieng',
    location: 'Kisumu',
    rating: 5,
    text: 'Comfort is everything for me and these pairs are genuinely easy to wear all day. They feel soft inside, light on the feet, and the delivery was smooth.',
    product: 'Comfort Walking Shoes',
    departments: ['Women', 'Kids'],
    date: 'May 2026',
  },
  {
    id: 4,
    name: 'Michael Oduya',
    location: 'Mombasa',
    rating: 5,
    text: 'The sporty pair I got is perfect for long days out. Great grip, breathable material, and a premium look that still feels practical.',
    product: 'Sports Running Shoes',
    departments: ['Men', 'Women'],
    date: 'March 2026',
  },
  {
    id: 5,
    name: 'Ann Nyambura',
    location: 'Nakuru',
    rating: 5,
    text: 'I love how Trendy Quest combines style with comfort. The pair I ordered made me feel confident straight away and the WhatsApp follow-up was very helpful.',
    product: 'Stylish Loafers',
    departments: ['Women'],
    date: 'May 2026',
  },
  {
    id: 6,
    name: 'Peter Kamau',
    location: 'Thika',
    rating: 5,
    text: 'Excellent customer service and quality products. The shoes arrived well packed, fit properly, and looked exactly like the photos.',
    product: 'Casual Boots',
    departments: ['Men'],
    date: 'February 2026',
  },
  {
    id: 7,
    name: 'Joyce Mutheu',
    location: 'Machakos',
    rating: 5,
    text: 'The handbag I ordered is neat, roomy, and easy to carry every day. It fits my essentials without looking bulky and the finishing is very clean.',
    product: 'Structured Handbag',
    departments: ['Bags'],
    date: 'May 2026',
  },
  {
    id: 8,
    name: 'Brian Mwangi',
    location: 'Nairobi',
    rating: 5,
    text: 'I picked a backpack for work and it has been solid. The straps are comfortable, the zip feels strong, and it easily carries my laptop and charger.',
    product: 'Work Backpack',
    departments: ['Bags'],
    date: 'April 2026',
  },
  {
    id: 9,
    name: 'Lucy Chebet',
    location: 'Kericho',
    rating: 5,
    text: 'The tracksuit set feels warm without being heavy. The fit is flattering, the fabric washes well, and the color stayed sharp after several wears.',
    product: 'Adult Tracksuit',
    departments: ['Clothes'],
    date: 'May 2026',
  },
  {
    id: 10,
    name: 'Mercy Njeri',
    location: 'Nyeri',
    rating: 5,
    text: 'I ordered for my child and the quality impressed me. The pair is sturdy, easy to clean, and comfortable enough for school and weekend errands.',
    product: 'Kids Daily Pair',
    departments: ['Kids'],
    date: 'March 2026',
  },
];

const normalizeReviewText = (value = '') =>
  String(value || '')
    .replace(/\s+/g, ' ')
    .replace(/\s+([,.;:!?])/g, '$1')
    .trim();

const normalizeReviewRating = (value) => {
  const rating = Number(value);
  if (!Number.isFinite(rating)) return 5;
  return Math.max(1, Math.min(5, Math.round(rating)));
};

const normalizeReview = (review = {}, index = 0) => ({
  id: review.id || `review-${index + 1}`,
  name: normalizeReviewText(review.name) || 'Verified customer',
  location: normalizeReviewText(review.location) || 'Kenya',
  rating: normalizeReviewRating(review.rating),
  text: normalizeReviewText(review.text),
  product: normalizeReviewText(review.product),
  date: normalizeReviewText(review.date),
});

export const parseProductReviews = (value = '') =>
  String(value || '')
    .replace(/\r\n?/g, '\n')
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line, index) => {
      const segments = line.split('|').map((segment) => segment.trim());
      const name = segments[0] || '';
      const location = segments[1] || '';
      const rating = segments[2] || 5;
      const possibleDate = segments.length >= 5 ? segments[segments.length - 1] : '';
      const reviewText =
        segments.length >= 5
          ? segments.slice(3, -1).join(' | ')
          : segments.slice(3).join(' | ');

      return normalizeReview(
        {
          id: `custom-review-${index + 1}`,
          name,
          location,
          rating,
          text: reviewText,
          product: '',
          date: possibleDate,
        },
        index
      );
    })
    .filter((review) => review.text);

export const getFallbackReviewsForDepartment = (department = '', limit = 4) => {
  const normalizedDepartment = String(department || '').trim();
  const departmentReviews = STORE_TESTIMONIALS.filter((review) =>
    review.departments?.includes(normalizedDepartment)
  );

  if (departmentReviews.length) {
    return departmentReviews.slice(0, limit).map(normalizeReview);
  }

  return STORE_TESTIMONIALS.slice(0, limit).map(normalizeReview);
};

export const getProductReviews = (product = {}, limit = 4) => {
  const customReviews = parseProductReviews(product?.reviews);

  if (customReviews.length) {
    return customReviews.slice(0, limit);
  }

  return getFallbackReviewsForDepartment(getProductDepartment(product), limit).map((review) => ({
    ...review,
    product: review.product || product?.name || '',
  }));
};

export const getReviewAggregate = (reviews = []) => {
  const reviewCount = Array.isArray(reviews) ? reviews.length : 0;
  if (!reviewCount) {
    return {
      averageRating: 0,
      reviewCount: 0,
    };
  }

  const total = reviews.reduce((sum, review) => sum + normalizeReviewRating(review?.rating), 0);
  return {
    averageRating: Math.round(((total / reviewCount) + Number.EPSILON) * 10) / 10,
    reviewCount,
  };
};
